var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "iconList"
  }, [_c('div', {
    staticClass: "iconLi"
  }, [_c('i', {
    staticClass: "iconfont",
    class: _vm.privateComputed
  })]), _c('div', {
    staticClass: "iconLi"
  }, [_c('i', {
    staticClass: "iconfont",
    class: _vm.speakerComputed
  })]), _vm.sourceType !== 'voip' && _vm.sourceType !== 'app' ? _c('div', {
    staticClass: "iconLi"
  }, [_c('i', {
    staticClass: "iconfont",
    class: _vm.cameraComputed
  })]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };